import Config from '../util/config'
import { Dayjs } from 'dayjs'

const baseUrl = 'https://api.supercontrol.co.uk/v3/Calendar'

export interface GetPriceResponse {
  enquiry: boolean
  specialOfferText: string
}

export const getPrice = async (start: Dayjs, nights: number): Promise<GetPriceResponse> => {
  const key = Config.get('calendarKey')
  const cottageId = Config.get('propertyCode')
  const response = await fetch(
    `${baseUrl}/GetPrice?cottageID=${cottageId}&key=${key}&startdate=${start.format('YYYY-MM-DD')}&numbernights=${nights}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  )

  return await response.json()
}
